module.exports = __webpack_public_path__ + "static/img/3-06.cc8f323.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-06.png
// module id = 233
// module chunks = 0